<template>
  <ion-page id="guarding-page">
    <ion-content>

    <div v-show="showTour">
       <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
    </div>

    <div id="the_statusline" :style="styleStatus">
      <span v-if="showThumb == 'down'">
        <ion-icon aria-hidden="true" :icon="thumbsDown" />
        <ion-icon aria-hidden="true" :icon="thumbsDown" />
      </span>
      <span v-if="showThumb == 'up'">
        <ion-icon aria-hidden="true" :icon="thumbsUp" />
        <ion-icon aria-hidden="true" :icon="thumbsUp" />
      </span>
      {{ statusString }}
      <span v-if="showThumb == 'down'">
        <ion-icon aria-hidden="true" :icon="thumbsDown" />
        <ion-icon aria-hidden="true" :icon="thumbsDown" />
      </span>
      <span v-if="showThumb == 'up'">
        <ion-icon aria-hidden="true" :icon="thumbsUp" />
        <ion-icon aria-hidden="true" :icon="thumbsUp" />
      </span>
      <p>&nbsp;</p>
      {{ instructionString }}
    </div>

    <div id="the_board" :style="styleBoard">
      <CMChessboard :fen="fen" :orientation="orientation" :boardSize="boardSize" 
      :emitPosition="emitPosition"
      :validMoves="availableMoves" :sparePieces="sparePieces"   :setSquareColor="squareColorArray"
      @board-position="boardPosition" />
    </div>
    <ActionSheet :heading="actionSheetHeading" :items="actionSheetButtons" 
                    :trigger="actionSheetTrigger"
                    @action-sheet-result="actionSheetResult">
      </ActionSheet> 
  </ion-content>
    
    <Toolbar id="the_toolbar" :elements="toolbarElements" :trigger="toolbarTrigger" 
                      :ignoreClicks="showTour" @toolbar-click="toolbarClick" />
  </ion-page>
</template>

<script setup>

  import { IonIcon,IonPage, IonContent,modalController } from '@ionic/vue';
  import { thumbsUp, thumbsDown } from 'ionicons/icons';

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'
  import ActionSheet from '@/components/ActionSheet.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import Toolbar from '@/components/Toolbar.vue'
  import CMChessboard from '@/components/CMChessboard.vue'

  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { ref, watch } from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useGetData } from '@/composables/getData.js'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { availableWidthHeight, calculateChessBoardRect , isScreenPortraitOrientation } from '@/composables/screenSize'
  import Tour from '@/components/Tour.vue'
  import { t } from "@/composables/translateText.js";

  const STATE_WAITING = 0
  const STATE_SHOWING_PIECES = 1
  const STATE_USER_REPLICATING = 2
  const STATE_SHOWING_RIGHT_ANSWER = 3 
  const STATE_SHOWING_USER_ANSWER = 4

  var problemState = STATE_WAITING

  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"
  const EMPTY_FEN = "8/8/8/8/8/8/8/8 w KQkq - 0 1"

  const orientation = ref("white")
  const fen = ref(EMPTY_FEN)
  const emitPosition = ref(0)
  var fenid = 0
  var currentUserFen = ""
  var answerFen = EMPTY_FEN
  var spareFen = EMPTY_FEN
  var desiredOption = ""
  var currentPiecesOption = 0
  var currentAreaOption = 0

  var optionDisplayArray = []
  var optionDisplaySelected = ""
  var optionHeading = ""

  // which option is being worked on in generic list
  var whichOptionIsGenericList = ""

  const toolbarTrigger = ref(0)

  const makeAnyMoves = [ { from : "any"}]
  const makeNoMoves = [ ]

  const actionSheetHeading = ref(t("Options"))

  const availableMoves = ref(makeNoMoves)

  const sparePieces = ref("static")
  const boardSize = ref(300)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  //console.log("*** Tour option",tourOption)
  const showTour = ref((tourOption == "show"))

  const STATUS_FONTSIZE = 20
  const STATUS_HEIGHT = STATUS_FONTSIZE * 1.2 + 4
  
  const statusString = ref(t("Click 'Get Next' to Begin"))
  const instructionString = ref("")

  const squareColorArray = ref([])

  const showThumb = ref("")

  const ActionStrings = {
          mine : t("Show Mine"),
          replicate : t("Replicate") + "!",
          answer : t("Show Actual"),
          check : t("Check Work")
  }

  const TOOLBAR_GET_NEXT = 0
  const TOOLBAR_ACTION = 1
  const TOOLBAR_OPTIONS = 2

  const toolbarElements = ref([
    { index : TOOLBAR_GET_NEXT, label : t("Get Next") ,disabled : false },
    { index : TOOLBAR_ACTION, label : ActionStrings.replicate ,disabled : true },
    { index : TOOLBAR_OPTIONS, label :t("Options") ,disabled : false, hasAction : true }
  ])

  const ACTION_OPTION_PIECES = 0
  const ACTION_OPTION_AREA = 1
 
  // OPTIONS Action sheet
  const actionSheetTrigger = ref(0)
  const actionSheetButtons = [
        { text: t("Piece Count"), data: { index: ACTION_OPTION_PIECES } },
        { text: t("Board Area"), data: { index : ACTION_OPTION_AREA } },
        { text: t("Cancel"), role: 'cancel',data: { index : -1}},
    ];

    // tour stuff
   const tourInfo = ref({
    id : "static",
    video : "",
    elements : [
      { id: "", title: t( "Visualizing a Static Board"), text : t("It is said that looking at the board while trying to work out a move sequence is more of a hindrance than a help.<br><br>Why? Because the board hides the ranks, files and diagonals that get opened up and closed down by piece movements.")},
      { id: "", title: t( "Holding the Board Image"), text : t("If you can hold the board in your head then it is easy to shift the pieces around and visualize the new board just as easily as the current board.<br><br>This isn't an easy task but Chessvis is here to help you build up your visualization talent.")},

      { id: "the_toolbar", title: t( "Get Next - Toolbar"), text : t("Will display the random set of pieces")},
      { id: "the_toolbar", title: t( "Replicate - Toolbar"), text : t("Do you have the image in your mind?<br><br>'Replicate' will position the pieces along the back rank ready for you to move them to the right squares.")},
      { id: "the_toolbar", title: t( "Check Work - Toolbar"), text : t("Done placing the pieces?<br><br>'Check Work' will tell you how well you did.<br><br>The button title will change to 'Show Mine' and 'Show Actual' so you can toggle back and forth.")},
      { id: "the_toolbar", title: t( "Options - Toolbar"), text : t("You have control over the number of pieces to place and how much of the board they take up")}
    ]
  })

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleStatus = ref({
    "text-align" : "center",
    "font-size" : "20px",
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    updateWidthHeights()
    menuTrigger.value++
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** WHO'S Guarding -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** REP TREE new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })
  
  function tourDone() {
    showTour.value = false
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boardSize.value + "px"
    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"

    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleStatus.value.height = boundaries['status'].height + "px"
    styleStatus.value.width = boundaries['status'].width + "px"
    styleStatus.value.top = boundaries['status'].top + "px"
    styleStatus.value.left = boundaries['status'].left + "px"

    //console.log("**** boardsize ",boardSize.value)
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)

    updateStyleObjects(boundaries)
   
  }

  function calculatePortraitWidthHeights(availableSpace) {

    // reserve space status message
    const availableSpaceForBoard = { width : availableSpace.width ,
                height : availableSpace.height - 100,
                isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = boardPositionTop + boardHeight
    const statusPositionLeft = availableSpace.leftRightIndent
    const statusWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : STATUS_HEIGHT,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    // reserve space status message
    const availableSpaceForBoard = { width : availableSpace.width - 150,
                height : availableSpace.height ,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)
  
    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = 0
    const statusPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const statusHeight = STATUS_HEIGHT
    const statusWidth = availableSpace.width - statusPositionLeft

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : STATUS_HEIGHT,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      }
    }
    //console.log("board and movelist dimensions",result)
    return (result)
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** static board -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** REP TREE new window size",windowSizeRef.value)
    updateWidthHeights()
  })

  function boardPosition(fen) {
    //console.log("fen back from board",fen)
    currentUserFen = fen
    checkFen(currentUserFen)
  }

  // Start ACTION LIST

  function actionClick(index) {
    switch (index) {
    case ACTION_OPTION_PIECES :
        desiredOption = "pieces"
        optionHeading = t("# of Pieces To Visualize")
        getOptions()
        break
      case ACTION_OPTION_AREA :
        desiredOption = "area"
        optionHeading = t("Area of Board")
        getOptions()
        break
    }
  }
  function actionSheetResult(action,index) {
    if (action != "yes")
      return
    actionClick(index)
  }

  // END Action List

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == optionDisplaySelected)
        return

      //console.log("CONFIRM in static",data)

      // send both to server, keeping the other value unchanged
      if (desiredOption == "pieces")
        setOptions(data.selected,currentAreaOption)
      else
      if (desiredOption == "area")
        setOptions(currentPiecesOption,data.selected)
    }
  };
  // END Generic Options List

  function toolbarClick(arrayIndex) {
    if (arrayIndex < 10 && toolbarElements.value[arrayIndex].disabled)
      return

    switch (arrayIndex) {
      case TOOLBAR_OPTIONS :
        //console.log("Click on Options")
        actionSheetTrigger.value++
        break
      case TOOLBAR_GET_NEXT :
        getFen()
        break
      case TOOLBAR_ACTION :
        if (problemState == STATE_SHOWING_PIECES) {
          // display pieces on back ranks
          fen.value = spareFen
          currentUserFen = spareFen
          availableMoves.value = makeAnyMoves
          problemState = STATE_USER_REPLICATING
          toolbarElements.value[TOOLBAR_ACTION].label = ActionStrings.check
          instructionString.value = ""
          toolbarTrigger.value++
        }
        else
        if (problemState == STATE_USER_REPLICATING) {
          availableMoves.value = makeNoMoves
          emitPosition.value++
        }
        else
        if (problemState == STATE_SHOWING_RIGHT_ANSWER) {
          problemState = STATE_SHOWING_USER_ANSWER
          fen.value = currentUserFen
          statusString.value = t("Board Shows Your Answer")
          toolbarElements.value[TOOLBAR_ACTION].label = ActionStrings.answer
          toolbarTrigger.value++
        }
        else
        if (problemState == STATE_SHOWING_USER_ANSWER) {
          problemState = STATE_SHOWING_RIGHT_ANSWER
          fen.value = answerFen
          statusString.value = t("Board Shows Actual Answer")
          toolbarElements.value[TOOLBAR_ACTION].label = ActionStrings.mine
          toolbarTrigger.value++
        }
        break
      case TOOLBAR_TOUR :
        showTour.value = true
        tourTrigger.value++
        break
    }
  }

  function processJsonResponse(json) {
    //console.log("response from static board",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    instructionString.value = t('Visualize the Board')
    answerFen = json['fen']
    spareFen = json['spare']
    fen.value = answerFen
    fenid = json['id']

    squareColorArray.value = []

    toolbarElements.value[TOOLBAR_GET_NEXT].label = t("Give Up")
    toolbarElements.value[TOOLBAR_ACTION].label = ActionStrings.replicate
    toolbarElements.value[TOOLBAR_ACTION].disabled = false

    toolbarTrigger.value++

    showThumb.value = ""
    statusString.value = ""
    problemState = STATE_SHOWING_PIECES
  }

  function getFen() {

    var formData = {
      e : 0
    }
    useGetData("getweb_random_fen.php", formData, processJsonResponse)
  }
 
  function processCheckFenJsonResponse(json) {
    //console.log("response from check fen",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    toolbarElements.value[TOOLBAR_GET_NEXT].label = t("Get Next")
    toolbarTrigger.value++

    problemState = STATE_SHOWING_RIGHT_ANSWER

    const errorCount = json['diff']

    if (errorCount == 100) {
      toolbarElements.value[TOOLBAR_ACTION].disabled = true
      statusString.value = t('Nothing Attempted')
      instructionString.value = ""
      showThumb.value = ""
      return
    }
    if (errorCount == 0) {
      statusString.value = t("No Errors") + "!"
      showThumb.value = "up"
      instructionString.value = ""
      toolbarElements.value[TOOLBAR_ACTION].label = t('No Errors')
      toolbarElements.value[TOOLBAR_ACTION].disabled = true
      return
    }

    const targets = json['wtarget'].split(" ")
    const tries = json['wtry'].split(" ")

    var bads = []
    for (var i = 0; i < targets.length; i++) {
      var found = 0
      for (var j=0; j < tries.length; j++)
        if (tries[j] == targets[i]) {
          found = 1
          break
        }
      if (found == 0)
        bads.push({square : targets[i], color : "red"})
    }
  for (var i = 0; i < tries.length; i++) {
      var found = 0
      for (var j=0; j < targets.length; j++)
        if (tries[j] == targets[i]) {
          found = 1
          break
        }
      if (found == 0)
        bads.push({square : tries[i], color : "red"})
    }
    statusString.value = t("Board Shows Actual Answer")

    squareColorArray.value = bads

    if (errorCount == 1)
      instructionString.value = "1 " + t("Error")
    else
      instructionString.value = errorCount + " " + t("Errors")

    toolbarElements.value[TOOLBAR_ACTION].label = ActionStrings.mine
    fen.value = answerFen
  }

  function checkFen(fen) {

    var formData = {
      id : fenid,
      timemem : 0,
      timebuild : 0,
      fen : fen,
      ismove : 0,
      eval : 0
    }
    useGetData("check_fen.php", formData, processCheckFenJsonResponse)
  }

  function processGetOptionsJsonResponse(json) {
    //console.log("response from options",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    currentPiecesOption = json['p']
    currentAreaOption = json['c']

    const initial = (desiredOption == "pieces") ? currentPiecesOption : currentAreaOption
    optionDisplayArray = []

    switch (desiredOption) {
      case "pieces" :
        for (var i = 1; i <= 32; i++) {
          const pieceString = (i == 1) ? t("Piece") : t("Pieces")

          const oneItem = { 
            index : i,
            name : i + " " + pieceString,
            id : i,
            radio : "" + i
          }
          optionDisplayArray.push(oneItem)
        }
        break
      case "area" :
        optionDisplayArray = [
          { index : 0, name : t("Eighth"),id : 9,radio : "9" },
          { index : 1, name : t("Quarter"),id : 16,radio : "16" },
          { index : 1, name : t("Half"),id : 16,radio : "32" },
          { index : 1, name : t("Full"),id : 32,radio : "64" },
        ]
        break
    }
  
    optionDisplaySelected = "" + initial

    //console.log("optionDisplayArray",optionDisplayArray)
    openGenericSingleListModal()
  }

  function getOptions() {

    var formData = {
      p : 0,
      c : 0
    }
    useGetData("get50_set_staticoptions.php", formData, processGetOptionsJsonResponse)
  }

  function processSetOptionsJsonResponse(json) {
    //console.log("response from options",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }

  function setOptions(pieceCount,areaSize) {

    var formData = {
      p : pieceCount,
      c : areaSize
    }
    useGetData("get50_set_staticoptions.php", formData, processSetOptionsJsonResponse)
  }
</script>

<style scoped>

</style>